import { ProductMediaItem } from '../reducers/product.reducer';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'getProductMediaUrl' })
export class GetProductMediaUrlPipe implements PipeTransform {
	transform(
		items: ProductMediaItem[],
		args: { index: number; thumbnail?: boolean },
	): string | undefined {
		const media = items[args.index];
		if (typeof media === 'object') {
			if (args.thumbnail) return media.fitIn_270x270;
			return items && items.length > 1 ? media.fitIn_470x470 : media.fitIn_670x670;
		}
		return media;
	}
}
